export const NOTIFICATION_SERVICE_INIT_FAILURE = "notificationServiceInitFailure";
export const NOTIFICATION_SERVICE_START_FAILURE = "notificationServiceStartFailure";
export const NOTIFICATION_SERVICE_STOP_FAILURE = "notificationServiceStopFailure";
export const VALID_SINCE_INVALID = "VALID_SINCE_INVALID";
export const FUEL_TYPE_NOT_ALLOWED = "FUEL_TYPE_NOT_ALLOWED";
export const OUTAGE_ACTIVATED = "outageActivated";
export const POST_CHARGE_ORDER_FAILURE = "postChargeOrderFailure";
export const NOTIFICATION_SERVICE_CONNECTION_ID_UNDEFINED = "connectionIdUndefined";
export const PERSISTENCE_ORDER_UPDATE_FAILURE = "persistenceOrderUpdateFailure";
export const CHARGE_ORDER_REQUEST_PROCESSING_FAILED = "CHARGE_ORDER_REQUEST_PROCESSING_FAILED";
